import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prospecting-form',
  templateUrl: './prospecting-form.component.html',
  styleUrls: ['./prospecting-form.component.scss']
})
export class ProspectingFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
